import React, { Component } from 'react';
import { Col, FormGroup, ControlLabel, FormControl, Panel, Glyphicon, Button } from 'react-bootstrap';

import Course from './Course';
import FormSectionStatus from './FormSectionStatus';
import { updateCollege, removeCourse, addCourse, updateCourse } from '../actions';
import { CourseValidation } from '../validation/educationValidation';
import { unitTypes } from '../config/constants';

class College extends Component {
  constructor(props){
    super(props);
    this.handleCollegeNameChange = this.handleCollegeNameChange.bind(this);
    this.handleCollegeLocationChange = this.handleCollegeLocationChange.bind(this);
    this.handleCollegeUnitTypeChange = this.handleCollegeUnitTypeChange.bind(this);
    this.handleCollegeChanges = this.handleCollegeChanges.bind(this);
    this.handleRemoveCollege = this.handleRemoveCollege.bind(this);
    this.handleRemoveCourse = this.handleRemoveCourse.bind(this);
    this.handleAddCourse = this.handleAddCourse.bind(this);
    this.handleUpdateCourse = this.handleUpdateCourse.bind(this);
  }

  handleCollegeNameChange(e){
    const updates = { name: e.target.value };
    this.handleCollegeChanges(updates);
  }

  handleCollegeLocationChange(e){
    const updates = { location: e.target.value };
    this.handleCollegeChanges(updates);
  }

  handleCollegeUnitTypeChange(e){
    const updates = { unitType: e.target.value };
    this.handleCollegeChanges(updates);
  }

  handleCollegeChanges(updates){
    const {dispatch, id} = this.props;
    dispatch(updateCollege(id, updates));
  }

  handleRemoveCollege(e){
    e.preventDefault();
    this.props.onRemoveCollege(this.props.id);
  }

  handleRemoveCourse(courseId){
    const {dispatch} = this.props;
    dispatch(removeCourse(this.props.id, courseId));
  }

  handleAddCourse(e){
    e.preventDefault();
    const {dispatch} = this.props;
    dispatch(addCourse(this.props.id));
  }

  handleUpdateCourse(courseId, updates){
    const {dispatch} = this.props;
    dispatch(updateCourse(this.props.id, courseId, updates));
  }

  render() {
    const { courses, validationState } = this.props;
    const space = ' ';
    const renderCourses = () => {
      if(courses.length === 0) {
        return (
          <Col xs={12}>
            Please add a course.
          </Col>
        )
      }

      return courses.map((course) => {
        return (
          <Course key={course.id}
                  {...course}
                  programId = {this.props.programId}
                  dispatch={this.props.dispatch}
                  onRemoveCourse={this.handleRemoveCourse}
                  onUpdateCourse={this.handleUpdateCourse}
                  validationState={new CourseValidation().getValidationStatus(course)}/>
        );
      });
    };

    const getUnitOptions = () => {
      return Object.keys(unitTypes).map((type) => {
        return (
          <option key={type} value={type}>{unitTypes[type]}</option>
        )
      });
    };

    const getSectionStatus = () => {
      return validationState.section.status === 'success' ? null : <FormSectionStatus {...validationState.section}/>;
    };

    return (
      <Panel className="college-panel">
        <div className="college-row">
          <Col sm={6}>
            <FormGroup
              controlId={`college-${this.props.id}-name`}
              validationState={validationState.name}>
              <ControlLabel>
                College Name
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="text"
                value={this.props.name}
                placeholder="Enter Name"
                onChange={this.handleCollegeNameChange}/>
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <FormGroup
              controlId={`college-${this.props.id}-location`}
              validationState={validationState.location}>
              <ControlLabel>
                College Location (City/State)
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="text"
                value={this.props.location}
                placeholder="Enter Location"
                onChange={this.handleCollegeLocationChange}/>
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col sm={2}>
            <FormGroup controlId={`college-${this.props.id}-units`}
                       validationState={validationState.unitType}>
              <ControlLabel>Unit Type</ControlLabel>
              <FormControl componentClass="select"
                           placeholder=""
                           value={this.props.unitType}
                           onChange={this.handleCollegeUnitTypeChange}>
                <option value="">Select</option>
                {getUnitOptions()}
              </FormControl>
            </FormGroup>
          </Col>
        </div>
        <div className="clearfix"/>
        <Panel className="course-list">
          {renderCourses()}
        </Panel>
        <div className="buttons">
          <Button onClick={this.handleAddCourse}
                  bsStyle="default"
                  className="pull-left">
            <Glyphicon glyph="plus"/>
            {space} Add Course
          </Button>
          <Button bsStyle="danger"
                  className="pull-right"
                  onClick={this.handleRemoveCollege}>
            <Glyphicon glyph="trash"/>
            {space} Remove College
          </Button>
        </div>
        <div className="clearfix"/>
        {getSectionStatus()}
      </Panel>
    );
  };
}

export default College;